module.exports = __webpack_public_path__ + "fonts/Caveat-400-latin-ext3.1eae1ba.woff2";